export class GetMembersWithAssessmentsList {
  static readonly type = '[Assessments viewer] Get members with assessments list';
}

export class SelectMemberWithAssessments {
  static readonly type = '[Assessments viewer] Select member with assessments';
  constructor(public payload: { memberGlobalId: number }) {}
}

export class GetSingleAssessment {
  static readonly type = '[Assessments viewer] Get single assessment';
  constructor(
    public payload: { memberGlobalId: number; assessmentGlobalId: number; fileId: number | null }
  ) {}
}
